<template>
  <header
    class="tw-flex tw-h-[64px] tw-shrink-0 tw-items-center tw-justify-between tw-border-b tw-bg-white tw-px-4 tw-text-grey-900"
  >
    <div class="tw-flex tw-items-center">
      <img class="tw-w-36 lg:tw-hidden" src="/images/logo_no_tagline.svg" />

      <div class="tw-hidden tw-place-items-center tw-gap-2 lg:tw-flex">
        <school-location-button
          v-if="!checkRole('webmaster')"
          :schoolname
          :locations
        />

        <template v-if="checkRole('webmaster')">
          <login-as-school-button />
          <login-as-employee-button />
          <login-as-student-dropdown />
        </template>

        <school-location-button
          v-if="checkRole('webmaster') && locations.length"
          :schoolname
          :locations
        />

        <header-student-search v-if="!checkRole('student')" />
      </div>
    </div>

    <div class="tw-flex tw-items-center tw-gap-2 tw-p-2">
      <div
        class="tw-flex [&>*:nth-child(n+3)]:tw-hidden lg:[&>*:nth-child(n+3)]:tw-block"
      >
        <header-icon-button
          v-for="(item, key) in headerIcons"
          :key
          :icon="item.icon"
          :badge="item.badge"
          @click="item.action"
        />
      </div>

      <div
        class="tw-mx-2 tw-hidden tw-h-5 tw-w-px tw-bg-gray-200 lg:tw-block"
      ></div>

      <div class="tw-hidden lg:tw-block">
        <logged-in-user-button />
      </div>

      <div class="lg:tw-hidden" @click="toggleMenu">
        <hamburger />
      </div>
    </div>
  </header>
</template>

<script setup>
import { bellIcon, giftIcon, toClassicIcon } from "common/defaultIcons";
import { SIDEBARS } from "shared/constants";
import { useSidebar } from "shared/composables/useSidebar";
import LoggedInUserButton from "components/buttons/LoggedInUserButton.vue";
import LoginAsEmployeeButton from "components/buttons/LoginAsEmployeeButton.vue";
import LoginAsSchoolButton from "components/buttons/LoginAsSchoolButton.vue";
import LoginAsStudentDropdown from "components/buttons/LoginAsStudentDropdown.vue";
import SchoolLocationButton from "components/buttons/SchoolLocationButton.vue";
import Hamburger from "components/layout/Hamburger.vue";
import HeaderIconButton from "components/layout/HeaderIconButton.vue";
import HeaderStudentSearch from "components/layout/HeaderStudentSearch.vue";
import { checkRole } from "composables/useHelpers.js";
import { useAuthStore } from "core/auth/auth.store";
import { storeToRefs } from "pinia";
import { useMenuStore } from "store/modules/menuStore.js";
import { computed, onMounted, ref } from "vue";

const { openSidebar } = useSidebar();

// menuStore
const menuStore = useMenuStore();
const { toggleMenu, supportMenuItem } = menuStore;

// Auth store
const authStore = useAuthStore();
const { loadCurrentUser } = authStore;
const { unseenFeaturesCount, unseenNotificationsCount } =
  storeToRefs(authStore);

// Refs
const locations = ref([]);
const schoolname = ref("");

onMounted(async () => {
  locations.value = JSON.parse(localStorage.getItem("menu_locations")) || [];
  schoolname.value = localStorage.getItem("school_name") || "";

  try {
    await loadCurrentUser();
  } catch (error) {
    console.error("Error fetching current user:", error);
  }
});

const headerIcons = computed(() => {
  return [
    {
      icon: toClassicIcon(bellIcon),
      badge: unseenNotificationsCount.value > 0 && {
        label: unseenNotificationsCount.value,
        color: "red",
        textColor: "white",
      },
      action: async () => {
        await openSidebar(SIDEBARS.NOTIFICATIONS);
      },
    },
    {
      icon: toClassicIcon(giftIcon),
      badge: unseenFeaturesCount.value > 0 && {
        label: unseenFeaturesCount.value,
        color: "blue",
        textColor: "white",
      },
      action: async () => {
        await openSidebar(SIDEBARS.FEATURES);
      },
    },
    {
      icon: supportMenuItem.meta?.icon,
      badge: false,
      action: supportMenuItem.action,
    },
  ];
});
</script>
